import { render } from "./signUpInfo.vue?vue&type=template&id=ea34be58"
import script from "./signUpInfo.vue?vue&type=script&lang=js"
export * from "./signUpInfo.vue?vue&type=script&lang=js"

import "./signUpInfo.vue?vue&type=style&index=0&id=ea34be58&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__